module.exports = __webpack_public_path__ + "img/free-slot-white.d6c11010.svg";